import { LessonActivity } from "./lesson-activity.types"


export class ActivityUtil {

  static activityName(activity?: LessonActivity): string | null {

    let name = ""
    name += activity?.activity_node?.[0]?.name || ""
    name += activity?.activity_node?.[0]?.node_name || ""
    name += activity?.activity_node?.[0]?.video_name || ""

    return name

  }

}

